<template>
  <div>
    <div v-if="showTaskList">
      <div class="-mt-2 mb-4 justify-end text-sm text-gray-500 sm:flex" v-if="withFilter">
        <label class="mr-3 flex items-center">
          <input type="checkbox" v-model="filter.showCompleted" class="mr-1" />
          {{ $t('task.show_completed') }}
        </label>
        <label class="flex items-center">
          <input type="checkbox" v-model="filter.assignedToMe" class="mr-1" />
          {{ $t('task.only_assigned_to_me') }}
        </label>
      </div>
      <div v-if="loading" class="flex items-center py-4 text-gray-500">
        <i class="fal fa-circle-notch fa-2x fa-spin mr-2"></i>
        <span>{{ $t('task.loading') }}...</span>
      </div>
      <div v-if="!loading">
        <task-list-item
          v-for="task in filteredTasks"
          :task="task"
          :users="users"
          :key="task.id"
          :small="small"
          :show-link="!activityId"
          @toggle-completed="toggleCompleted(task)"
          @update-title="updateTitle(task)"
          @update-description="updateDescription(task)"
          @assign-user="assignUser"
          @set-due-date="setDueDate"
          @delete="deleteTask(task)"
        ></task-list-item>
        <task-list-item
          :task="newTask"
          @update-title="createNew(newTask)"
          v-if="canCreate"
          class="print:hidden"
        ></task-list-item>
      </div>
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  props: {
    activityId: {
      type: Number,
    },
    limit: {
      type: Number,
    },
    showCompleted: {
      type: Boolean,
      default: true,
    },
    showOnlyAssignedToMe: {
      type: Boolean,
      default: false,
    },
    withFilter: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filter: {
        showCompleted: false,
        assignedToMe: false,
      },
      canCreate: false,
      tasks: [],
      users: [],
      newTask: {
        title: '',
      },
      loading: true,
    }
  },
  methods: {
    toggleCompleted(task) {
      task.loading = true

      let completed = !task.completedAt

      axios
        .patch('/api/activity-tasks/' + task.id + '/complete', { completed })
        .then(({ data }) => {
          task.loading = false
          task.completedAt = data.completedAt
          task.completedBy = data.completedBy
        })
        .catch((error) => {
          console.log(error)
        })
    },
    updateTitle(task) {
      axios
        .patch('/api/activity-tasks/' + task.id, { title: task.title })
        .then(({ data }) => {
          task.title = data.title
        })
        .catch((error) => {
          console.log(error)
        })
    },
    updateDescription(task) {
      axios
        .patch('/api/activity-tasks/' + task.id, { description: task.description })
        .then(({ data }) => {
          task.description = data.description
        })
        .catch((error) => {
          console.log(error)
        })
    },
    deleteTask(task) {
      axios
        .delete('/api/activity-tasks/' + task.id)
        .then(({ data }) => {
          task.deleted = true

          this.tasks = this.tasks.filter((el) => {
            return !el.deleted
          })
        })
        .catch((error) => {
          console.log(error)
        })
    },
    createNew() {
      if (!this.newTask.title) {
        return
      }

      axios
        .post(
          '/api/activities/' + this.activityId + '/tasks',
          {
            title: this.newTask.title,
          },
          {
            headers: {
              'x-task-permissions': true,
            },
          }
        )
        .then(({ data }) => {
          this.tasks.push(data)
          this.newTask.title = ''
        })
        .catch((error) => {
          console.log(error)
        })
    },
    assignUser({ task, user }) {
      axios
        .patch('/api/activity-tasks/' + task.id, { assignee_id: user.id })
        .then(({ data }) => {
          task.assigneeId = data.assigneeId
        })
        .catch((error) => {
          console.log(error)
        })
    },
    setDueDate({ task, dueDate }) {
      axios
        .patch('/api/activity-tasks/' + task.id, { due_date: dueDate })
        .then(({ data }) => {
          task.dueDate = data.dueDate
          task.rawDueDate = data.rawDueDate
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },
  computed: {
    filteredTasks() {
      let tasks = this.tasks

      if (this.showCompleted && this.withFilter && !this.filter.showCompleted) {
        tasks = tasks.filter((task) => {
          return !task.completedAt
        })
      }

      if (this.filter.assignedToMe) {
        tasks = tasks.filter((task) => {
          return task.assignedToMe || task.completedByMe
        })
      }

      return tasks
    },
    showTaskList() {
      return this.loading || this.canCreate || this.tasks.length > 0
    },
  },
  created() {
    let tasksUrl = this.activityId
      ? '/api/activities/' + this.activityId + '/tasks'
      : '/api/activity-tasks'

    if (this.showOnlyAssignedToMe) {
      this.filter.assignedToMe = true
    }

    axios
      .get(tasksUrl, {
        params: {
          limit: this.limit,
          showCompleted: this.showCompleted ? null : false,
        },
        headers: {
          'x-task-permissions': true,
          'x-user-names': !this.activityId,
        },
      })
      .then(({ data, headers }) => {
        this.tasks = data
        this.canCreate = headers['x-tasks-create'] === '1'
        this.loading = false
      })
      .catch((error) => {
        console.log(error)
      })

    if (this.activityId) {
      axios
        .get('/api/activities/' + this.activityId + '/users')
        .then(({ data }) => {
          this.users = data
        })
        .catch((error) => {
          console.log(error)
        })
    }
  },
}
</script>
